/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import SEOLocaleList from '@apps/components/SEOLocaleList';
import { BASE_URL } from '@apps/config';
import getAuthors from '@apps/config/API/authors';
import AuthorListingScreen from '@apps/screens/AuthorListing';
import { Breadcrumb } from '@stack/ui/components';
import { BreadCrumbOptions } from '@stack/ui/components/Breadcrumb/props';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const Page: NextPage = (props) => {
  const { webView } = props;
  const router = useRouter();
  const { lang, t } = useTranslation('common');

  const [data, setData] = useState<any>();
  const [loading, setloading] = useState<boolean>(false);

  const fetchData = async () => {
    try {
      setloading(true);
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth' as any,
        });
      }, 0);

      const res = await getAuthors();

      if (res.data.length < 1) {
        router.replace(webView ? '/webview/404' : '/404');
        return;
      }
      setData(res);
      setloading(false);
    } catch (err) {
      console.log('err', err);
    }
  };

  const authors = data;

  useEffect(() => {
    setData(null);
    fetchData();
  }, [router?.asPath, router?.locale]);

  const breadcrumbOpt: BreadCrumbOptions[] = [
    {
      title: t('news'),
      url: webView ? '/webview' : '/',
    },
    {
      title: t('authors'),
    },
  ];

  const currentUrl =
    lang === 'en'
      ? `${BASE_URL}${router?.asPath}`
      : `${BASE_URL}/${lang}${router?.asPath}`;
  const cleanedPath = currentUrl.split('?')[0].toLowerCase();

  return (
    <>
      <NextSeo canonical={cleanedPath} />
      <SEOLocaleList />
      <div>{<Breadcrumb options={breadcrumbOpt} />}</div>
      <AuthorListingScreen
        data={authors?.data}
        webView={webView}
        loading={loading}
        href={`/authors`}
      />
    </>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Page;
